module.exports = __webpack_public_path__ + "img/product8.1741fc93.png";